import { useEffect, useState } from "react";
// import { useStripe, Elements } from "@stripe/react-stripe-js";
import { useLocation, useNavigate, useParams } from "react-router-dom";
// import { getFunctions, httpsCallable } from "firebase/functions";
import IntroFlightsPayment from "./IntroFlightsPayment";
import { calculateFees, createPaymentIntent } from "src/services/payments.api";

export default function IntroFlightsPaymentWrapper({ ...rest }) {
  const { clubId, locationId } = useParams();
  // const stripe = useStripe();
  const [paymentIntent, setPaymentIntent] = useState(null);
  const [calculatedFees, setCalculatedFees] = useState(null);
  const [paymentIntentSecret, setPaymentIntentSecret] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  const [bookingData, setBookingData] = useState();

  useEffect(() => {
    if (!location.state) {
      const url = window.location.pathname;
      navigate(url.replace("/payment", ""));
    } else {
      setBookingData(location.state);
    }
  }, [location]);

  useEffect(() => {
    if (!bookingData) return;
    const { introFlight, passengerData } = bookingData;
    console.log("Booking Data:", bookingData);
    if (introFlight?.totalPrice && passengerData?.email) {
      // const functions = getFunctions();
      // const createIntroFlightPaymentIntent = httpsCallable(
      //   functions,
      //   "createIntroFlightPaymentIntent"
      // );
      // createIntroFlightPaymentIntent({
      //   clubId,
      //   locationId,
      //   email: bookingData.passengerData.email,
      //   introFlightId: introFlight.id,
      // }).then((result) => {
      //   if (result?.data) {
      //     setPaymentIntentSecret(result.data.secret);
      //     setPaymentIntent(result.data.id);
      //   } else {
      //     console.error("Unable to create Stripe payment intent", result);
      //   }
      // });
      calculateFees({
        paymentMethod: "CARD_FWD",
        amount: Math.round(introFlight.totalPrice * 100),
        clubId,
        locationId,
        dissmissPreFlightFee: false,
      }).then((fees) => {
        setCalculatedFees(fees);
        createPaymentIntent({
          amount: Math.round(introFlight.totalPrice * 100),
          currency: "USD",
          referenceId: introFlight.id,
          userId: passengerData.userId || "IntroFlight",
          clubId,
          fees,
          locationId,
          paymentMethodTypes: ["card"],
        }).then((result) => {
          if (result.id) {
            console.log("FWD payment intent", result);
            setPaymentIntent(result);
          } else {
            console.error("Unable to create FWD payment intent", result);
          }
        });
      });
    }
  }, [bookingData]);

  return paymentIntent && bookingData ? (
    // <Elements stripe={stripe} options={{ clientSecret: paymentIntentSecret }}>
    <IntroFlightsPayment
      bookingData={bookingData}
      paymentIntent={paymentIntent}
      fees={calculatedFees}
      {...rest}
    />
  ) : // </Elements>
  null;
}
